(function ($) {
	$(function () {
		$('.form__label.phone input').mask('+7 (999) 999-99-99');
	});
})(jQuery);